/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMmsCampaign = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 2v20H4V2zm-5.036 8.378-8.965 6.619L6 20h12.001L18 13.415zM14 16v2h-4v-2zm4.001-12H6l-.001 10.482 9.037-6.86L18 10.585zM8.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMmsCampaign as MmsCampaign };
